// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__u4pUz","footerLinks":"Footer_footerLinks__r0Gel","footerCopyright":"Footer_footerCopyright__u-imX"};